import { render, staticRenderFns } from "./PricingPolicy.vue?vue&type=template&id=d23a84ac&"
import script from "./PricingPolicy.vue?vue&type=script&lang=js&"
export * from "./PricingPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports